import axios from 'axios';
const API_URL = 'https://cava-don-carlos.herokuapp.com/api/v1/';

const renewPassword = (data: any) => {
    return axios.put(`${API_URL}users/renewPassword`, data);
}

export const API = {
    renewPassword
}